module.exports = __webpack_public_path__ + "img/11wh0-eeva3.2fa9cf19.png";